import { Navbar } from '../components/layout/Navbar';
import { Footer } from '../components/layout/Footer';
import { AgentHero } from '../components/sections/agent/AgentHero';
import { AgentFeatures } from '../components/sections/agent/AgentFeatures';
import { AgentCTA } from '../components/sections/agent/AgentCTA';

export default function AgentPage() {
  return (
    <div data-testid="agent-page" className="min-h-screen bg-[#020209]">
      <Navbar />
      <main>
        <AgentHero />
        <AgentFeatures />
        <AgentCTA />
      </main>
      <Footer />
    </div>
  );
}
